import Tickets from './tickets-container';

export default Tickets;
